<template>
    <div class="layout-container">
        <div class="main-container">
            <div class="sidebar">
                <div class="menu-sidebar-top">
                     <img src="../assets/logo.png" alt="Dayruns">
                </div>
                <div class="menu-sidebar">
                    <router-link class="sub-menu" to="/home"><i class="fa fa-home"></i>&nbsp;Overview </router-link>
                    <router-link class="sub-menu" to="/bookings"><i class="fa fa-bank"></i>&nbsp;Bookings  </router-link>
                    <router-link class="sub-menu" to="/models"><i class="fa fa-users"></i>&nbsp;Models  </router-link>
                    <router-link class="sub-menu" to="/guests"><i class="fa fa-users"></i>&nbsp;Guests  </router-link>
                    <router-link class="sub-menu" to="/boosted-models"><i class="fa fa-paw" aria-hidden="true"></i>&nbsp;Boosted Models  </router-link>
                    <router-link class="sub-menu" to="/models-subscription-plan"><i class="fa fa-users"></i>&nbsp;Models Subscription Plan  </router-link>
                    <router-link class="sub-menu" to="/boost-plans"><i class="fa fa-users"></i>&nbsp;Boost Plans  </router-link>
                    <router-link class="sub-menu" to="/guest-subscriptions"><i class="fa fa-bank"></i>&nbsp;Guest Subscriptions  </router-link>
                    <router-link class="sub-menu" to="/truth-dare"><i class="fa fa-briefcase"></i>&nbsp;Truth & Dare  </router-link>
                    <router-link class="sub-menu" to="/price-setup"><i class="fa fa-cog"></i>&nbsp;Price Setup  </router-link>
                    <router-link class="sub-menu" to="/package-setup"><i class="fa fa-cog"></i>&nbsp;Package Setup  </router-link>
                    <router-link class="sub-menu" to="#"><i class="fa fa-headphones" aria-hidden="true"></i>&nbsp;Help Center  </router-link>
                    <div class="sub-menu" style="cursor: pointer" @click="vendorLogout()">&nbsp;<i class="fa fa-sign-out"></i> Logout</div>
                </div>
               
            </div>
    
            <div class="content">
                <div class="top-header">
                    <div class="notifications menu-bar">
                        <span @click="show_menu()"><i class="fa fa-bars"></i></span>
                        <div class="submenu-bar" v-if="isMenuOpen">
                            <div class=" d-flex flex-row justify-content-between font-weight-bolder"> <button class="close-menu" @click="close_menu()">X</button></div>
                            <div class="menu-sidebar-top">
                                <img src="../assets/logo.png" alt="Dayruns">
                            </div>
                            <div class="sub-menu1"  @click="close_menu('/home')"><i class="fa fa-home"></i>&nbsp;Overview </div>
                            <div class="sub-menu1"  @click="close_menu('/bookings')"><i class="fa fa-users"></i>&nbsp;Bookings  </div>
                            <div class="sub-menu1"  @click="close_menu('/models')"><i class="fa fa-users"></i>&nbsp;Models  </div>
                            <div class="sub-menu1"  @click="close_menu('/guests')"><i class="fa fa-users"></i>&nbsp;Guests  </div>
                            <div class="sub-menu1"  @click="close_menu('/boosted-models')"><i class="fa fa-users"></i>&nbsp;Boosted Models  </div>
                            <div class="sub-menu1"  @click="close_menu('/models-subscription-plan')"><i class="fa fa-users"></i>&nbsp; Models Subscription Plan  </div>
                            <div class="sub-menu1"  @click="close_menu('/boost-plans')"><i class="fa fa-users"></i>&nbsp; Boost Plans  </div>
                            <div class="sub-menu1"  @click="close_menu('/guest-subscriptions')"><i class="fa fa-users"></i>&nbsp; Guest Subscriptions  </div>
                            <div class="sub-menu1"  @click="close_menu('/truth-dare')"><i class="fa fa-users"></i>&nbsp; Truth & Dare  </div>
                            <div class="sub-menu1"  @click="close_menu('/price-setup')"><i class="fa fa-cog"></i>&nbsp; Price Setup  </div>
                            <div class="sub-menu1"  @click="close_menu('/package-setup')"><i class="fa fa-cog"></i>&nbsp; Package Setup  </div>
                            <div class="sub-menu1" to="#"><i class="fa fa-headphones" aria-hidden="true"></i>&nbsp;Help Center  </div>
                            <div class="sub-menu1" style="cursor: pointer" @click="vendorLogout()">&nbsp;<i class="fa fa-sign-out"></i> Logout</div>
                        </div>
                    </div>      
                    <div>
                       
                    </div>
                    <div class="message-notifications d-flex align-items-center">
                    <!-- Bell Notification -->
                    <span class="notifications bell me-3">
                        <i class="fa fa-bell"></i>
                    </span>

                    <!-- User Avatar with Dropdown -->
                    <div class="dropdown">
                        <a
                        href="#"
                        class="d-flex align-items-center text-decoration-none dropdown-toggle"
                        id="userDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style="font-size: 12px;"
                        >
                        {{ username }}
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end shadow" aria-labelledby="userDropdown">
                        
                        <!-- <li><a class="dropdown-item" href="#">Profile</a></li>
                        <li><hr class="dropdown-divider"></li> -->
                        <li>
                            <a class="dropdown-item text-danger" href="#" @click="vendorLogout()">
                            <i class="fa fa-sign-out me-2"></i> Logout
                            </a>
                        </li>
                        </ul>
                    </div>
                    </div>
       
                </div>
                <router-view/>
            </div>
            <div class="footer">
                    &copy;{{ new Date().getFullYear() }} {{ appTitle }} All rights reserved.
                </div>
        </div>
    </div>
    
</template>
<script>
import inactivityMixin from '../mixins/inactivityMixin';
export default {

    name: "Dashboard",
    mixins: [inactivityMixin],
    components: {

    },

    data(){
        return {
            appTitle: 'Dayruns',
            username: '',
            email: '',
            name_initial: '',
            pageTitle: '',
            isMenuOpen: false,
            user: {
                avatar: ''
            }
        };
    },

    created() {
    this.$root.$on('title', (title) => {
      this.pageTitle = title;
        });
    },
    beforeDestroy() {
        this.$root.$off('title');
    },
      
    beforeMount(){
        document.title = this.appTitle
    },
    mounted() {
        this.username = localStorage.getItem("username");
        this.email = localStorage.getItem("email");

        if (this.firstname) {
        this.name_initial = this.firstname.charAt(0);
        } else {
        this.name_initial = ''; // Handle the case where firstname is empty
        }
    },
   
    computed: {
        
    },
    methods:{
       
        show_menu(){
            this.isMenuOpen = true; // Show the submenu-bar
        },
        close_menu(router){
            this.isMenuOpen = false; // Show the submenu-bar
            this.$router.push(router)
        },
        vendorLogout(){
            localStorage.removeItem("wertyuiojhdfghhdrtfyguh")
            localStorage.removeItem("username");
            localStorage.removeItem("lastname");
            localStorage.removeItem("phone");
            localStorage.removeItem("email");
            localStorage.removeItem("userid");
            this.$router.push("/login")
        }
    }
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
.dropdown-menu{
    padding: 0;
}
.close-menu{
    font-size: 18px;
}
.rounded-circle{
    border-radius: 44px;
    padding: 10px;
    border: solid 0.5px #333;
}
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.search-bar{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.top-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px 15px 20px;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.038);
}
.message-notifications{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
}
  
.envelope{
    color: #ccc;
    cursor: pointer;
    padding-right: 10px;
}
.bell{
    color: #D33E74;
    cursor: pointer;
}
.inputs-field{
    font-size: 14px;
    font-family: Poppins;
    height: 45px;
    width: 400px;
    border-radius: 0px;
    position: relative;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #cccccc2b;
    border: solid 0px;
}
.search-button{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem;
    background: #cccccc2b;
    color: #ccc;
    border-radius: 0px;
    font-family: Poppins;
    font-size: 18px;
    text-transform: capitalize;
    height: 45px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.logo-title {
    padding: 30px 30px 20px;
    font-family: Poppins;
    font-size: 13px;
    font-weight: 800;
    color: #fff;
    flex: 1;
    border-bottom: solid 1px #ccc;
}

.menu-bar {
    flex: 2;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.menu-bar .submenu-bar {
    display: none;
}

.menu-bar .fa-bars:hover + .submenu-bar,
.menu-bar .submenu-bar:hover {
    display: block;
    position: absolute;
    background: #D33E74;
}

.user-info {
    flex: 1;
    text-align: right;
}

.dropdown .dropbtn {
    background-color: #D33E74;
    color: #000;
    padding: 12px;
    font-size: 12px;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    width: 100%;

    span{
        color: white;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0px;
        width: 30px;
        height: 30px;
        background: #312F33;
        border-radius: 47px;
        margin: 10px;
    }
}

.main-container {
    display: flex;
    flex: 1;
}
.menu-sidebar-top {
    display: flex;
    flex-direction: column;
    justify-content:center;
    align-items: center;
    padding: 50px 30px 0;

    .username{
        font-size: 24px;
        font-weight: 700;
        line-height: 30px;
        font-family: Poppins;
        font-weight: 500;
        text-transform: capitalize;
        color: #fff;
    }
    .email{
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 400;
        line-height: 1px;
        color: #7F7F7F;

    }
    img{
        width: 60%
    }
}
.menu-sidebar {
    padding: 20px 10px 0;
}

.sidebar {
    background: #000000ef;
    box-shadow: 2px 0 5px rgba(0,0,0,0.1);
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 200px; /* Adjust this width according to your design */
    overflow-y: auto; /* Allows scrolling if the content is longer than the viewport */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    z-index: 1000; /* Keeps it on top of other elements */
}

.sidebar::-webkit-scrollbar {
    display: none;
}

.sidebar .sub-menu {
    display: block;
    padding: 0.5rem;
    color: #ccc;
    font-family: Poppins;
    font-size: 10px;
    font-weight: normal;
    text-decoration: none;
    margin-left: 10px;
    padding: 10px 10px 10px 10px;
   
}

.sidebar .sub-menu:hover {
    background: #030303;
    color: #fff;
    border-top-left-radius: 9.26px;
    border-bottom-left-radius: 9.26px;
    border-right: solid 2px #D33E74;
}

.content {
    flex: 1;
    width: 100%;
    margin-left: 200px; /* This should match the sidebar width */
    padding: 20px; /* Optional: add some padding */
    background: #F5F5F5;
}

.footer {
    position: absolute;
    text-align: center;
    padding: 10px;
    background: #fff;
    color: #D33E74;
    bottom: 0;
    min-width: 100%;
    //box-shadow: 0 -1px 2px rgba(0,0,0,0.1);
}

 .menu-bar{
    display:none;
 }

 .logo-title{
    display:block;
 }

/* Style The Dropdown Button */
.dropbtn {
   // background-color: #4CAF50;
    color: white;
    //padding: 16px;
    font-size: 16px;
    border: none;
    cursor: pointer;
  }
  
  /* The container <div> - needed to position the dropdown content */
  .dropdown {
    position: relative;
    display: inline-block;
  }
  
  /* Dropdown Content (Hidden by Default) */
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: #000;
    color: #f1f1f1 !important;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }
  
  /* Links inside the dropdown */
  .dropdown-content a {
    color: black;
    padding: 3px 16px;
    text-decoration: none;
    display: block;
    border-bottom: solid 1px #ccc;
  }
  
  /* Change color of dropdown links on hover */
  .dropdown-content a:hover {background-color: #474646}
  
  /* Show the dropdown menu on hover */
  .dropdown:hover .dropdown-content {
    display: block;
  }
  
  /* Change the background color of the dropdown button when the dropdown content is shown */
  .dropdown:hover .dropbtn {
    //background-color: #3e8e41;
  }
#green {
    height: 100%;
    background: #fff;
    text-align: center;
    color: black;
    font-family: Poppins;
}
.dropdown-menu {
    margin-left: 250px;
    background: #fff;

    .dropdown-item:hover{
        color: #ff4d63;
        font-weight: 650;
    }
}
.navbar-bgcolor{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #D33E74c7;
    color: #fff;
    font-family: Poppins;
    box-shadow: 0 4px 6px -3px rgba(0, 0, 0, 0.3);

    a{
        color: #fff !important;
        text-decoration: none;
        font-size: 15px !important;
        font-weight: normal !important;

        img{
            width: 60px;
        }
    }
    a:hover{
        color: #fff;
    }
}
.navbar-brand{
    font-weight: 700;
    font-size: 14px !important;
}
.nav-link:hover{
    background: #f1b3ac;
    border-radius: 4px;
}

@media screen and (max-width: 768px) { 

    .top-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px 15px 10px;
        box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.038);
        width: 100%;
        background: #fff;
    }
    .search-bar{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .menu-sidebar-top {
        display: flex;
        flex-direction: column;
        justify-content:center;
        align-items: center;
        padding: 10px 10px 0;
    
        .username{
            font-size: 24px;
            font-weight: 700;
            line-height: 30px;
            font-family: Poppins;
            font-weight: 500;
            text-transform: capitalize;
            color: #fff;
        }
        .email{
            font-family: Montserrat;
            font-size: 12px;
            font-weight: 400;
            line-height: 1px;
            color: #7F7F7F;
    
        }
        img{
            width: 20% !important;
        }
    }
    .inputs-field{
        width: 100%;
    }
    .message-notifications{
        display: inline;
    }
    .notifications{
       margin: 5px;
    }
    .envelope{
        padding-right: 0px;
    }
    .envelope:hover{
        cursor: pointer;
    }
    .bell:hover{
        cursor: pointer;
    }

    .sidebar{
        display: none;
    }
    .content {
        flex: 1;
        width: 100%;
        margin-left: 0px; /* This should match the sidebar width */
        padding: 0px; /* Optional: add some padding */
    }
    .logo-title{
        display: none;
    }
    .submenu-bar{
        display:block;
        justify-content: left;
        height: 50%;
        overflow-y: auto; /* Allows scrolling if the content is longer than the viewport */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        z-index: 1000; /* Keeps it on top of other elements */
        img{
            cursor: pointer;
        }
     }
     .submenu-bar::-webkit-scrollbar {
        display: none;
    }

    .menu-bar{
        display:block;
       justify-content: left;
       cursor: pointer;
       
     }
     .menu-bar:hover{
        
            .submenu-bar{
                display: flex;
                flex-direction: column;
                background: #181818;
                top: 0;
                left: 0;
                font-family: Poppins;
                font-size: 10px;
                border-right: solid 1px rgba(0, 0, 0, 0.3);
                position: fixed;
                z-index: 9998;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                width: 100%;
                height: 100%;
                left: -2px;
                padding: 38px 49px 38px 49px;
                            
                a{
                    text-decoration: none;
                    //color: #312F33;
                }
                img{
                    width: 50% !important
                }
                button{
                    margin-top: 20px;
                    color: #fff
                }
            }
            .sub-menu1{
                display: flex;
                flex-direction: row;
                justify-content: left;
                align-items: center;
                //border-left: solid 1px #ccc;
                //border-bottom: solid 1px #ccc;
                text-transform: capitalize;
                cursor: pointer;
                padding: 0.4rem;
                width: 100%;
                color: #ccc;
                text-decoration: none;
                padding: 10px 10px 10px 10px;
                border-top-left-radius: 9.26px;
                border-bottom-left-radius: 9.26px;
            }
     }
     .sub-menu1:hover{
        background: #030303;
        border-right: solid 2px #D33E74;
     }
     
    .menu{
        display: none;       
    }
    .dropdown-menu {
        margin-left: 0;
    }

    .dropdown {
        font-size: 12px;
      }
    
    .avater{
        font-size: 12px;
        display: flex;
    }
    .navbar-bgcolor{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #D33E74c7;
        color: #fff;
        font-family: Poppins;
       box-shadow: 0 4px 6px -3px rgba(0, 0, 0, 0.3);
    
        a{
            color: #fff !important;
            text-decoration: none;
            font-size: 13px !important;
            font-weight: normal !important;
    
            img{
                width: 50px;
            }
        }
        a:hover{
            color: #fff;
        }
    }
}

</style>